<template>
  <div class="basket-body">
    <BasketEmpty v-if="isBasketEmpty()"></BasketEmpty>

    <BasketList v-if="showProductListForm() && !isBasketEmpty()"></BasketList>

    <BasketAuth v-bind:classes="{box: 'basket basket-auth'}" v-if="showAuthorizeForm() && !isBasketEmpty()"></BasketAuth>

    <div class="basket-checkout" v-if="showCheckoutForm() && !isBasketEmpty()">
      <BasketDelivery></BasketDelivery>

      <BasketPayment></BasketPayment>
    </div>

    <div class="basket-checkout" v-if="isConfirmOrder && order.id !== null">
      <BasketOrder></BasketOrder>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import BasketDelivery from "./Delivery";
import BasketList from "./List";
import BasketAuth from "./Auth";
import BasketPayment from "./Payment";
import BasketOrder from "./Order";
import BasketUtils from "./BasketUtils";
import BasketEmpty from "./BasketEmpty";

export default {
  name: "BasketBody",
  methods:{
    showProductListForm: function () {
      if(this.order.created === true){
        return false;
      }
      if(this.isCheckout){
        if(!this.isUserAuthorize || this.isSizeMd) {
          return false;
        }
      }
      return true;
    },
    showAuthorizeForm: function () {
      return !this.isUserAuthorize && this.isCheckout && this.order.created !== true && this.order.processing !== true;
    },
  },
  computed: {
    ...mapGetters('order', {
      order: 'getOrderInfo',
      isCheckout: 'getIsCheckout',
      isConfirmOrder: 'getIsConfirmOrder',
    }),
    ...mapGetters('user', {
      isUserAuthorize: 'isAuthorize',
    }),
    ...mapGetters('app', {
      isSizeMd: 'getIsSizeMd',
    }),
  },
  components: {
    BasketDelivery,
    BasketList,
    BasketAuth,
    BasketPayment,
    BasketOrder,
    BasketEmpty
  },
  mixins: [BasketUtils]
}
</script>

<style scoped>

</style>